module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3336a4516746eca7bc4a8e981e51a981.svg";